export const Colors = {
  orange: "#ef7481",
  darkOrange: "#d06a75",
  darkBlue: "#1e2538",
  lightBlue: "#109CF1",

  mediumGrayText: '#707683',


  blue: "#0B5CD7",
  violet: "#561188",
  lightViolet: '#6714A3',
  extraLightViolet: '#CCB1E0',
  grayText: "#616161",
  darkGray: "#424242",
  lightPink: '#F5B1C9',
  pink: '#E0155C',

  green: '#008243',
  lightGreen: '#B3DAC7',
  extraLightGreen: '#EBF5F0',
  yellow: '#F4C417',
  lightYellow: '#FFCA99',
  extraLightYellow: '#FFF2E7',
  red: '#BB114D',
  lightRed: '#FFD7D7',
  extraLightRed: '#FFECEC',
  dangerRed: '#E00000',
  dangerRedHover: '#E00000',

  whiteBackground: '#FEFDFB',
  grayBorder: '#E6E6E6',
  whiteText: '#F2ECF9',
  yellowText: '#FFC160',

  primary98: '#FEFDFB',
  primary95: '#FEFDFB',
  primary90: '#F5EBD6',
  primary80: '#FFD799',
  primary70: '#FFC160',
  primary50: '#FF9C00',
  primary40: '#CC7C00',
  primary20: '#663E00',

  secondary98: '#FAF7FC',
  secondary95: '#F2ECF9',
  secondary90: '#E6DEED',
  secondary80: '#CDBDDB',
  secondary70: '#B39CC9',
  secondary50: '#814DB2',
  secondary40: '#4F1783',
  secondary20: '#340F57',
  secondary10: '#1A082B',

  neutral98: '#FFFFFF',
  neutral90: '#E3E6E8',
  neutral80: '#C8CCD0',
  neutral70: '#ACB3B9',
  neutral50: '#758089',
  neutral30: '#464D53',
  neutral20: '#2F3337',
  neutral10: '#232629',

  error100: '#FFF2F2',
  error95: '#F5D6D8',
  error60: '#DB575F',
  error20: '#7D1C24',

  warning100: '#FFFBF2',
  warning95: '#FCEACE',
  warning60: '#F6B756',
  warning20: '#BA750A',

  success100: '#EDF8E7',
  success95: '#C6D5CA',
  success60: '#769A80',
  success20: '#1F4523',

  info100: '#EDF8E7',
  info95: '#D1E3F3',
  info60: '#4F99D3',
  info20: '#1F3245',

  gray2: '#4F4F4F'
};
